import { UnstyledButton, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown } from '@tabler/icons-react';
import { translate } from '@/lib';
import { useStore } from '@/store';
import clsx from 'clsx';
import style from './BottomNav.module.scss';
import { isNavItemActive, type NavItem } from './bottomNavTypes';

type BottomNavGroupProps = {
  item: NavItem;
  currentPath: string;
  onNavigate: (path: string) => void;
};

export function BottomNavGroup({ item, currentPath, onNavigate }: BottomNavGroupProps) {
  const isIngameBrowser = useStore((s) => s.isIngameBrowser);
  const [opened, { toggle, close }] = useDisclosure(false);

  const children = item.children ?? [];
  const isGroupActive = children.some((child) => isNavItemActive(child.path, currentPath));

  const handleChildClick = (path: string) => {
    onNavigate(path);
    close();
  };

  return (
    <div className={style.moreWrapper}>
      <UnstyledButton
        onClick={toggle}
        className={clsx(style.navItem, style.groupItem, { [style.active]: isGroupActive })}
      >
        <span
          className={clsx(
            style.groupArrow,
            isIngameBrowser ? style.groupArrowRight : style.groupArrowTop,
            { [style.groupArrowOpen]: opened }
          )}
        >
          <IconChevronDown size={12} />
        </span>
        <div className={style.navIcon}>{item.icon}</div>
        <Text size="xs" className={style.navLabel}>
          {translate(item.translationKey, item.label)}
        </Text>
      </UnstyledButton>

      {opened && (
        <>
          <div className={style.backdrop} onClick={close} />
          <div
            className={clsx(
              style.moreFlyout,
              isIngameBrowser ? style.moreFlyoutHorizontal : style.moreFlyoutVertical
            )}
          >
            {children.map((child) => (
              <UnstyledButton
                key={child.path}
                onClick={() => handleChildClick(child.path)}
                className={clsx(style.navItem, {
                  [style.active]: isNavItemActive(child.path, currentPath),
                })}
                style={{ width: 'auto' }}
              >
                <div className={style.navIcon}>{child.icon}</div>
                <Text size="xs" className={style.navLabel}>
                  {translate(child.translationKey, child.label)}
                </Text>
              </UnstyledButton>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BottomNavGroup;
